// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"ec66c0c8","238":"5854dad5","334":"cf069312","380":"2b6023aa","527":"d300dd41","538":"2d2b625d","787":"a32ce743","815":"fed5e9a7"}[chunkId] + ".chunk.js";
};